module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.2303a108.png";